import FadeTransition from './FadeTransition.vue';
import AppSpinner from './AppSpinner.vue';
import AppInfiniteScroll from './AppInfiniteScroll.vue';
import AppButton from './AppButton.vue';
import AppNumber from './AppNumber.vue';
import AppInput from './AppInput.vue';

export default [FadeTransition, AppSpinner, AppInfiniteScroll, AppButton, AppNumber, AppInput];
